import component from './ja-JP/component';
import globalHeader from './ja-JP/globalHeader';
import menu from './ja-JP/menu';
import pages from './ja-JP/pages';
import pwa from './ja-JP/pwa';
import settingDrawer from './ja-JP/settingDrawer';
import settings from './ja-JP/settings';
import fixOverlay from './ja-JP/fix_overlay';
import fixOpenapi from './ja-JP/fix_openapi';
import fixAdminMisc from './ja-JP/fix_adminmisc';
import fixBilling from './ja-JP/fix_billing';
import fixComponents from './ja-JP/fix_components';
import fixConsoleMisc from './ja-JP/fix_consolemisc';
import fixGap from './ja-JP/fix_gap';
import fixSystemconfig from './ja-JP/fix_systemconfig';
import fixTenant from './ja-JP/fix_tenant';
import fixVoiceClone from './ja-JP/fix_voiceclone';
import fixTodo from './ja-JP/fix_todo';
import fixLedger from './ja-JP/fix_ledger';


export default {
  'navBar.lang': '���Z',
  'layout.user.link.help': '�إ��',
  'layout.user.link.privacy': '�ץ饤�Х��`',
  'layout.user.link.terms': '����Ҏ�s',
  'app.preview.down.block':
    '���Υک`������`����ץ��������Ȥ˥�������`�ɤ��Ƥ�������',
  'app.welcome.link.fetch-blocks': '���٤ƤΥ֥��å���ȡ��',
  'app.welcome.link.block-list':
    '�֥��å��_�k�ե�`���`����ʹ�ä���Ѹ�٤˘˜ʵĤʥک`��������',
  ...fixConsoleMisc,
  ...fixComponents,
  ...fixAdminMisc,
  ...fixBilling,
  ...fixTenant,
  ...fixVoiceClone,
  ...fixGap,
  ...fixSystemconfig,
  ...fixOpenapi,
  ...fixTodo,
  ...fixLedger,
};
